import Image from '@anm/components/image/Image';
import { media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

import Button from '../buttons/Button';

import { ListItemProps } from './types';

const wrapperOnTablet = media.tablet`
  padding: 0 24px;
  margin: 30px 0;;
`;

export const Wrapper = styled.div`
  padding: 0 65px;
  margin: 50px 0 68px 0;

  ${wrapperOnTablet};
`;

export const ListWrapper = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const itemActiveStyles = css`
  background: #ebeef5;
`;

const hoverStyles = css`
  &:hover {
    background: #f5f7fa;
  }
`;

const numberedItemOnTablet = media.tablet`
  margin-right: 2px;;
`;

const numberedItemStyles = css`
  &:not(:last-of-type) {
    margin-right: 4px;

    ${numberedItemOnTablet}
  }

  ${hoverStyles};
`;

const commonPrevNextItemsStyles = css`
  padding: 0 10px;
  ${hoverStyles};
`;

const prevButtonOnTablet = media.tablet`
  margin-right: 11px;
`;

const nextButtonOnTablet = media.tablet`
  margin-left: 9px;;
`;

const prevButtonStyles = css`
  margin-right: 44px;

  ${prevButtonOnTablet};
  ${commonPrevNextItemsStyles};
`;

const nextButtonStyles = css`
  margin-left: 40px;

  ${nextButtonOnTablet};
  ${commonPrevNextItemsStyles};
`;

const disabledItemStyles = css`
  a,
  span {
    pointer-events: none;
    color: #919eaa;
  }

  &:hover {
    background: transparent;
  }
`;

const separatorSyles = css`
  ${hoverStyles};
`;

const listItemLinkOnTablet = media.tablet`
  min-width: 32px;
  line-height: 32px;
`;

export const ListItem = styled.li<ListItemProps>`
  border-radius: 5px;
  a,
  span {
    font-size: 16px;
    line-height: 25px;
    color: #292a2b;
    font-weight: bold;
    line-height: 36px;
    min-width: 36px;
    display: flex;
    user-select: none;
    align-items: center;
    justify-content: center;

    ${listItemLinkOnTablet};
  }

  ${({ isNumber, isSeparator }) => (isNumber || isSeparator) && numberedItemStyles};
  ${({ isDisabled }) => isDisabled && disabledItemStyles}
  ${({ isSelected }) => isSelected && itemActiveStyles};
  ${({ isSeparator }) => isSeparator && separatorSyles};
  ${({ isPrev }) => isPrev && prevButtonStyles};
  ${({ isNext }) => isNext && nextButtonStyles};
`;

export const ShowMoreButton = styled(Button)`
  display: block;
  text-align: center;
  background: #f5f7fa;
  border: 1px solid rgba(1, 83, 130, 0.2);
  border-radius: 5px;
  margin: 0 0 30px;
  font-weight: bold;
  font-size: 16px;
  line-height: 30px;
  color: #292a2b;
  user-select: none;

  &:hover {
    color: #292a2b;
    background: #ebeef5;
  }
`;

export const Icon = styled(Image)<{ isNext: boolean }>`
  ${({ isNext }) =>
    isNext &&
    css`
      transform: rotate(180deg);
    `}
`;
